'use client';

import React from 'react';
import { PlayerProfile } from '@wwe-portal/entities/player.type';
import { useTranslations } from 'next-intl';
import ProfileDetailsContainer from '../ProfileDetailsContainer';
import Link from 'next/link';
import RoasterTalent from '../PlayerDetails/PlayerAccount/RoasterTalent';
import ProfileDetailsBadge from '../PlayerDetails/ProfileDetailsBadge';
import ProfileDetailsCard from '../PlayerDetails/ProfileDetailsCard';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { tryFormatThousands } from '@wwe-portal/utils/format';
import { slugify } from '@wwe-portal/web/utils/string';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

function PlayerFactionDetails({
  playerProfile,
}: Readonly<{
  playerProfile: PlayerProfile;
}>) {
  const t = useTranslations();
  const { isMobile, isHydrated } = useResponsive();
  const showMobile = isHydrated && isMobile;

  return (
    <div>
      <span className="mb-[30px] text-lg font-medium md:mb-0 md:text-xl">
        {t('faction_stats')}{' '}
        <span
          className={`text-sm ${showMobile ? 'text-lightSteelBlue' : 'text-text500'}`}
        >
          ({t('player_stats_within_faction')})
        </span>
      </span>
      <div className="faction-details profile-details mt-[30px]">
        <ProfileDetailsContainer>
          <div className="flex flex-col items-center md:flex-row md:justify-between">
            <div
              className={`faction-account-container ${showMobile ? 'flex w-full flex-col items-center' : ''}`}
            >
              <p
                className={`mb-[10px] text-sm font-medium ${showMobile ? 'text-chetwodeBlue' : 'text-text600'}`}
              >
                {t('faction_name')}
              </p>
              <Link
                href={`/faction/${slugify(playerProfile?.alliance_name || '')}`}
                className={`font-semibold no-underline ${showMobile ? 'text-md text-decoration-none' : 'text-xl'}`}
                data-id={`player_faction_details_${playerProfile.alliance_name}`}
              >
                {playerProfile.alliance_name}
              </Link>
              <RoasterTalent
                rosterTalent={tryFormatThousands(
                  playerProfile.faction_total_roster_talent
                )}
              />
            </div>
            {showMobile && <hr className="hr-profile my-10" />}
            <div className="flex w-full flex-col items-center md:basis-[280px] md:flex-row">
              <ProfileDetailsBadge
                data={playerProfile.alliance_rank}
                title={t('rank')}
                bgImg="/assets/images/player/profile-badge_2.webp"
              />
              <div
                className={`profile-details-item faction ${showMobile ? 'mb-5 ml-0 mt-[30px] w-full px-5 pt-[10px]' : '3xl:flex'} flex flex-wrap`}
              >
                <div className="3xl:flex-row flex w-full flex-col items-center md:flex-row">
                  <ProfileDetailsCard
                    icon={
                      <IcoMoonIcon
                        iconName="time"
                        className="text-green700 size-6"
                      />
                    }
                    count={tryFormatThousands(playerProfile.days_in_faction)}
                    title={t('days_in_faction')}
                  />
                </div>
              </div>
            </div>
          </div>
        </ProfileDetailsContainer>
      </div>
    </div>
  );
}

export default PlayerFactionDetails;
